/** Розшифрувати не вдалося. Окремо від «конверт не той» — це різні причини. */
export class DecryptionFailedError extends Error {
    constructor(reason) {
        super(`не вдалося розшифрувати: ${reason}`);
        this.name = "DecryptionFailedError";
    }
}
//# sourceMappingURL=cipher.js.map